export const REPORT_MOTIVE_CARD_COLORS = ['#EEC873', '#D5422D', '#FE883D', '#6DCBFB', '#27AE60']

export const REPORT_CHART_CARD_SX = {
  borderRadius: 2,
  border: '3px solid #E4E4E4',
  backgroundColor: '#FFFFFF',
  height: { xs: 'auto', md: 220 },
  minHeight: { xs: 260, md: 220 },
  width: '100%',
  boxShadow: 'none'
}

export const REPORT_MOTIVE_CARD_SX = REPORT_CHART_CARD_SX
